"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableHeader(_ref) {
  var columns = _ref.columns,
      _ref$removeItem = _ref.removeItem,
      removeItem = _ref$removeItem === void 0 ? false : _ref$removeItem;
  return /*#__PURE__*/_react.default.createElement("tr", null, columns.map(function (col) {
    var label = col.label,
        field = col.field;
    return /*#__PURE__*/_react.default.createElement(_atoms.ColumnHeader, {
      key: field,
      column: col,
      field: field,
      label: label
    });
  }), removeItem && /*#__PURE__*/_react.default.createElement("th", null, " "));
}

TableHeader.propTypes = {
  columns: _propTypes.default.array.isRequired,
  removeItem: _propTypes.default.bool
};
var _default = TableHeader;
exports.default = _default;